export default "__VITE_ASSET__BcgjOX34__"